module.exports = __webpack_public_path__ + "img/9.2cc83057.jpeg";